import { ResultatValg, SET_VISNING, ResultatActionTypes, UPDATE_VALIDERING } from './Types';

const initialState: ResultatValg = {
    visBoksB: false,
    visBoksC: false,
    visBoksD: false,
    visBoksE: false,
    visBoksF: false,
    visDelvisResultat: false,
    visResultat: false,
    visFordeling: false,
    fValidation: undefined,
    visGenerellFeil: false,
};

export function resultatReducer(state: ResultatValg = initialState, action: ResultatActionTypes): ResultatValg {
    switch (action.type) {
        case SET_VISNING: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case UPDATE_VALIDERING: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
}
